import Link from "next/link";

import getLink from "@/lib/storyblok/getLink";
import type { LinkStoryblok } from "@/types/blok-types";

const SBLink = ({ blok, ...props }: { blok: LinkStoryblok }) => {
  const linkUrl = getLink(blok.link);
  const linkText = blok.text;

  const blankProps = blok.targetBlank
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  if (linkUrl)
    return (
      <Link {...props} {...blankProps} href={linkUrl}>
        {linkText}
      </Link>
    );
  throw new Error("No url was found on this link");
};
export default SBLink;
